import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import * as UserDataConfig from '../config/user-data.config';
import * as BreadCrumbConfigData from '../../../common-components/config/user-data.config';

import { Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NavigationEnd } from '@angular/router';
import { AppState } from '../../../store/state/app.state';
import { Store } from '@ngrx/store';
import { SessionTimeoutService } from 'src/app/shared/services/api-services/session-timeout.service';
import { Observable } from 'rxjs';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { FooterComponent } from '../../../common-components/footer/footer.component';
import { BreadcrumbComponent } from '../../../common-components/breadcrumb/breadcrumb.component';
import { HeaderComponent } from '../../../common-components/header/header.component';

@Component({
    selector: 'app-after-apply',
    templateUrl: './after-apply.component.html',
    styleUrls: ['./after-apply.component.scss'],
    imports: [HeaderComponent, BreadcrumbComponent, RouterOutlet, FooterComponent]
})
export class AfterApplyComponent {
  userForm: UntypedFormGroup;
  headerTitle: string;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public breadcrumbConfig = BreadCrumbConfigData.BreadcrumbConfig;
  enableBreadCrumbFeature:boolean=true;
  enableHeader:boolean=true;
  enableFooter:boolean=true;
  showOnlyRouterOutLetPage=false;
  private responseApplicationData: any[];
  private responseApplicationDataStore: Observable<any[]>;
  displayBeneficiaryDetails:boolean= false;
  constructor(private fb: UntypedFormBuilder, private router: Router,private store: Store<AppState>, private _sessionTimeoutSrv: SessionTimeoutService) {
    /*  getting values stored in applicationDataResponse store to display beneficiary page */
    this.responseApplicationDataStore = this.store.select(STORE_VAL.application_data_response);
    this.responseApplicationDataStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.responseApplicationData = val[0];
        this.displayBeneficiaryDetails= val[0]['showBeneficiary'];
        
      } else if (val && val.length === 0) {
        this.responseApplicationData = val;
      }
    });
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        // tslint:disable-next-line: max-line-length
        if (this.router.url === '/apply/congratulations'  || this.router.url === '/apply/user-login-required') {
          this.enableBreadCrumbFeature = false;
        }
        if (this.router.url.indexOf('/apply/clear-to-apply?quoteRef') > -1) {
          this.enableHeader = false;
        }
        
      });
      /* to show beneficiary details breadcrumb when shoebeneficiary is true */
      if(this.displayBeneficiaryDetails=== true){
      this.breadcrumbConfig.data.values.find(val => val.path==='/apply/your-beneficiary-details').enable=true;
    }
   }


}